import { combineKeys, queryKey } from '../../../../utils/queryUtils';

const titlesKey = queryKey('title');

export const purchasesKey = queryKey('purchases');
export const rentalsKey = queryKey('rentals');

export const productsKey = queryKey('products', (platformTitleId: string) => [platformTitleId]);

// We include the purchasesKey and rentalsKey because the titles will
// be updated when the purchases or rentals change.
export const purchasedTitlesKey = combineKeys(() => [purchasesKey(), titlesKey()]);
export const rentedTitlesKey = combineKeys(() => [rentalsKey(), titlesKey()]);

export const subscribedTitlesKey = combineKeys(() => [purchasedTitlesKey(), rentedTitlesKey()]);
export const subscribedProductsKey = combineKeys(() => [purchasesKey(), rentalsKey()]);
